import { assertEvent, assign } from 'xstate';

import { createLogic as createControlActorLogic } from './actors/control/logic';
import { machine } from './orchestrationMachine';

export const createLogic = () =>
	machine.provide({
		actors: {
			controlActorSrc: createControlActorLogic(),
		},
		actions: {
			syncDraft: assign({
				draft: ({ event }) => {
					assertEvent(event, 'sync_draft');
					return event.draft;
				},
			}),
		},
	});
